import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from "react-datepicker";

import Moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { SKTBaseComponent } from "./SKTBaseComponent";
import fi from "date-fns/locale/fi";

registerLocale("fi", fi);
setDefaultLocale("fi");

const enumerateDaysBetweenDates = (startDate, endDate) => {
  let dates = [];

  let currDate = Moment(startDate).startOf("day");
  let lastDate = Moment(endDate).startOf("day");

  while (currDate.add(1, "days").diff(lastDate) < 0) {
    dates.push(currDate.clone());
  }

  return dates;
};

const isWeekend = (date) => date.isoWeekday() === 6 || date.isoWeekday() === 7;

export const getStartDate = () => {
  const now = Moment(new Date());
  let startDate = now.clone();
  if (startDate.hour() > 11) {
    startDate.add(1, "day");
  }
  while (isWeekend(startDate)) startDate.add(1, "day");

  return startDate;
};

export const SKTDatePicker = ({ data, id, label, maxDays }) => {
  const onchange = (date) => {
    const value = Moment(date).format("D.M.Y");
    console.log("set", value);
    data.set(id, value);
  };

  const startDate = getStartDate();
  let endDate = startDate.clone();
  endDate.add(31, "day");

  const selectedDate = (dateString) => {
    const result = Moment(dateString, "D.M.Y");
    const r = result.isValid() ? result.toDate() : startDate.toDate();
    console.log("get", r);
    return r;
  };

  const excludeDates = enumerateDaysBetweenDates(startDate, endDate)
    .filter(isWeekend)
    .map((date) => date.toDate());

  return (
    <SKTBaseComponent data={data} id={id} label={label} childrenToLeft={true}>
      <DatePicker
        locale="fi"
        dateFormat="d.M.yyyy"
        selected={selectedDate(data.get(id))}
        id={id}
        name={id}
        excludeDates={excludeDates}
        onChange={onchange}
        onSelect={onchange}
        maxDate={endDate.toDate()}
        minDate={startDate.toDate()}
      />
    </SKTBaseComponent>
  );
};
